import React, { useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useToasts } from 'react-toast-notifications'
import { useHistory } from 'react-router-dom'

import { EntityCardProps } from '../../../components/organisms/EntityCard'
import {
  getCompany,
  deleteCompany,
  createCompany
} from '../../../domain/usecases/Company'

import { FilterItem } from '../../../components/organisms/EntityFilter'
import { EntityList } from '../../../components/organisms/EntityList'
import { getEntitiesCount } from '../../../domain/usecases/Reports'
import { filtersFactory } from '../../../main/factories/filters.factory'
import { convertCompanyToEntity } from '../../../domain/converters/Company'
import { DeleteModal } from '../../../components/molecules/DeleteModal'
import { useDispatch } from 'react-redux'
import { usePermissions } from '../../../hooks/usePermissions'

type ListCompaniesProps = {
  remoteGetCompanies: getCompany
  remoteDeleteCompany: deleteCompany
  remoteCreateCompany: createCompany
  remoteGetEntitiesCount: getEntitiesCount
}

export const ListCompanies = ({
  remoteGetCompanies,
  remoteDeleteCompany,
  remoteGetEntitiesCount,
  remoteCreateCompany
}: ListCompaniesProps) => {
  const history = useHistory()
  const { can } = usePermissions()

  const [companies, setCompanies] = React.useState<EntityCardProps[]>([])
  const [filters, setFilters] = useState<FilterItem[]>([])
  const dispatch = useDispatch()

  const { addToast } = useToasts()

  const [selectedId, setSelectedId] = useState('')
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const deleteCompanyFunction = (idSpe: string) => {
    handleShow()
    setSelectedId(idSpe)
  }

  const handleDelete = () => {
    remoteDeleteCompany
      .deleteById({ id: selectedId })
      .then((res) => {
        requestCompanies()
        handleClose()
      })
      .catch((error) => {
        handleClose()
        addToast(error.message, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  const RedirectToCompanyDetails = (id: string) => {
    history.push(`/companies/${id}`, { id: id })
  }

  const requestCompanies = async () => {
    remoteGetCompanies
      .getAll()
      .then((companies) => {
        setCompanies(
          convertCompanyToEntity(
            companies,
            can.delete('companies') ? deleteCompanyFunction : undefined,
            can.read('companies') ? RedirectToCompanyDetails : undefined,
            undefined // Photo upload removed
          )
        )
      })
      .catch((error) =>
        addToast('Não foi possível carregar as Incorporadoras.', {
          appearance: 'error',
          autoDismiss: true
        })
      )
  }

  React.useEffect(() => {
    requestCompanies()
    remoteGetEntitiesCount
      .getEntitiesCount()
      .then((entitiesCount) =>
        setFilters(filtersFactory(entitiesCount, history))
      )
  }, [])

  return (
    <>
      <DeleteModal
        show={show}
        handleClose={handleClose}
        handleOk={handleDelete}
      />
      <EntityList
        title="Incorporadora"
        activeFilter={0}
        buttons={
          <Button
            onClick={() => history.push('/companies/create')}
            variant="primary"
          >
            Adicionar Incorporadora
          </Button>
        }
        filters={filters}
        entityCards={companies}
      />
    </>
  )
}
